import {useTranslation} from '@aboutyou/i18n';
import {COLORS, ProductColorOptionsProps, Text} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

interface SizeReminderPopupProps {
  colorOptions: ProductColorOptionsProps['options'] | null;
  className?: string;
  ColorOptionsComponent?: React.ReactNode;
}

export const SoldOutState: React.FC<SizeReminderPopupProps> = ({
  ColorOptionsComponent,
  colorOptions,
}) => {
  const {t} = useTranslation();

  const colorSoldOutText = t('Your color is sold out');
  const defaultSoldOutText = t('This product is sold out');

  return (
    <Wrapper>
      <Headline size="px16" weight="bold">
        {colorOptions ? colorSoldOutText : defaultSoldOutText}
      </Headline>
      <StyledText size="px12" color="Grey0">
        {t('We can remind you as soon as the product is back in stock.')}
      </StyledText>
      {colorOptions && (
        <>
          <Text size="px16" weight="bold">
            {t('Discover other colours')}
          </Text>
          {ColorOptionsComponent}
        </>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding-top: 1.5rem;
  border-top: 1px solid ${COLORS.Grey4};
`;

const Headline = styled(Text)`
  display: block;
  margin-bottom: 10px;
`;

const StyledText = styled(Text)`
  display: block;
  line-height: 1.5;
  margin-bottom: 24px;
`;
